import api from '@app/api'

import type { InternalTasksNotificationDto } from './dtos'
import type { DefaultParams } from '@app/api/types'
import type { AblePaginatedResponseFn } from '@app/api/dtos'

const URL = '/internal-tasks/notifications/'

export const getInternalTasksNotification: AblePaginatedResponseFn<
DefaultParams,
InternalTasksNotificationDto
> = async () => {
  const response = await api.get(URL)
  return response.data
}
